<template>
  <div class="portrait">
    <el-card class="box-card" shadow="never" :body-style="{ padding: '12px' }">
      <el-button type="success" @click="addPortrait()">新增</el-button>
    </el-card>
    <div class="table_wrap" style="height: 300px;">
      <el-table ref="portraitTable" stripe border style="width: 100%" height="100%" max-height="100%" :data="portraitTable" v-loading="portraitTableLoading">
        <el-table-column type="index"></el-table-column>
        <el-table-column property="addDate" label="添加时间" width="150"></el-table-column>
        <el-table-column property="remark" label="画像" min-width="150"></el-table-column>
        <el-table-column label="相关操作" prop="monthQty" width="80">
        <template #default="{ row }">
          <el-button type="primary" @click="addPortrait(row)" size="mini">编辑</el-button>
        </template>
      </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    portraitPropData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      portraitTableLoading: false,
      portraitTable: []
    };
  },
  created() {
    this.getPortrait();
  },
  methods: {
    addPortrait(row = {}) {
      let { id = '', remark = '' } = row
      console.log(remark, id);
      let { enterpriseCode, enterpriseName } = this.portraitPropData;
      this.$prompt("请输入一条画像", remark ? '编辑画像' : '新增画像', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType: 'textarea',
        inputValue: remark,
        inputPattern: /\S/,
        inputErrorMessage: remark ? '编辑画像' : '新增画像' + "不能为空",
      })
        .then(async ({ value }) => {
          console.log(value);
          const loading = this.$loading({
            lock: true,
            text: remark ? '编辑' : '新增' + "中，请耐心等待",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          const { data: res } = await this.$http.post(
            remark ? "/Account/monitorCenterOperationRecord/updateRecord.html" : "/Account/monitorCenterOperationRecord/addRecord.html",
            this.Qs.stringify({
              remark: value,
              enterpriseCode,
              enterpriseName,
              id
            })  
          );
          loading.close();
          console.log(res);
          if (!res.success) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.getPortrait();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    async getPortrait() {
      this.portraitTableLoading = true;
      let { enterpriseCode } = this.portraitPropData;
      const { data: res } = await this.$http.post(
        "/Account/monitorCenterOperationRecord/selectRecordList.html",
        this.Qs.stringify({ enterpriseCode })
      );
      this.portraitTableLoading = false;
      this.portraitTable = res.rows;
    },
  },
}
</script>

<style>

</style>